import { TranslateFunction } from 'react-localize-redux';
import { FilterType } from 'typings';
import { FilterArguments } from '../hooks/useFilter';

export function getInitialFilterValues(
  type: FilterArguments,
  translate: TranslateFunction
): FilterType[] {
  if (type === 'buildingBlocks')
    return [
      {
        id: 1,
        type: 'search',
        value: '',
      },
      {
        id: 2,
        name: translate('filters.phase-filter.activity-per-step.title'),
        tooltip: translate('filters.process-step-filter.tooltip2'),
        type: 'process',
        value: [],
      },
      // {
      //   id: 3,
      //   name: translate('filters.skill-filter.title'),
      //   tooltip: translate('filters.skill-filter.tooltip'),
      //   type: 'dropdown',
      //   dropdownType: 'skill',
      //   initialText: translate('filters.skill-filter.select'),
      //   value: [],
      // },
    ];
  if (type === 'projects')
    return [
      {
        id: 1,
        type: 'search',
        value: '',
      },
      {
        id: 2,
        name: translate('filters.category-filter.title'),
        tooltip: translate('filters.category-filter.tooltip'),
        type: 'dropdown',
        dropdownType: 'category',
        initialText: translate('filters.category-filter.select'),
        value: [],
      },
      {
        id: 3,
        name: translate('project.publication-popups.bron-settings'),
        tooltip: translate('filters.bron-filter.tooltip'),
        type: 'dropdown',
        dropdownType: 'source',
        initialText: 'Groow Content',
        value: [],
      },
    ];
  if (type === 'courses')
    return [
      {
        id: 1,
        type: 'search',
        value: '',
      },
      {
        id: 2,
        name: translate('filters.category-filter.title'),
        tooltip: translate('filters.category-filter.tooltip'),
        type: 'dropdown',
        dropdownType: 'category',
        initialText: translate('filters.category-filter.select'),
        value: [],
      },
      {
        id: 3,
        name: translate('project.publication-popups.publication-settings'),
        tooltip: translate('filters.publication-filter.tooltip'),
        type: 'dropdown',
        options: ['course.terms.public-library'],
        dropdownType: 'publication',
        initialText: translate(
          'project.publication-popups.publication-settings'
        ),
        value: [],
      },
    ];
  if (type === 'my-courses')
    return [
      {
        id: 1,
        type: 'search',
        value: '',
      },
      {
        id: 2,
        name: translate('filters.category-filter.title'),
        tooltip: translate('filters.category-filter.tooltip'),
        type: 'dropdown',
        dropdownType: 'category',
        initialText: translate('filters.category-filter.select'),
        value: [],
      },
      {
        id: 3,
        name: translate('project.publication-popups.publication-settings'),
        tooltip: translate('filters.publication-filter.tooltip'),
        type: 'dropdown',
        options: [
          'general.terms.private',
          'course.terms.public-library',
          'course.terms.drafts',
        ],
        dropdownType: 'publication',
        initialText: translate(
          'project.publication-popups.publication-settings'
        ),
        value: [],
      },
    ];
  if (type === 'my-work')
    return [
      {
        id: 1,
        name: translate('filters.filter-menu.sort-on'),
        tooltip: translate('filters.filter-menu.sort-on-tooltip'),
        type: 'dropdown',
        dropdownType: 'sort',
        value: '',
        initialText: translate('general.terms.all'),
      },
      {
        id: 2,
        name: translate('filters.phase-filter.activity-per-step.title'),
        tooltip: translate('filters.process-step-filter.tooltip'),
        type: 'process',
        value: [],
      },
      {
        id: 3,
        name: translate('project.terms.activities'),
        tooltip: translate('project.terms.activities'),
        type: 'dropdown',
        dropdownType: 'activity',
        initialText: translate('filters.activity-filter.select'),
        value: [],
      },
      // {
      //   id: 4,
      //   name: 'Vaardigheden',
      //   tooltip: translate('project.terms.activities'),
      //   type: 'dropdown',
      //   dropdownType: 'activity',
      //   initialText: translate('filters.activity-filter.select'),
      //   value: [],
      // },
      {
        id: 4,
        name: 'Beoordeeld',
        tooltip: 'Laat alleen Werk zien wat beoordeeld is door een beoordelaar',
        type: 'checkbox',
        value: false,
      },
    ];

  return [];
}
